// Base URL for the NestJS backend API.
// Override per-environment with the Vue CLI env var VUE_APP_API_BASE_URL
// (e.g. http://localhost:3000 for local dev); defaults to the production backend.
export const apiBaseUrl = (
  process.env.VUE_APP_API_BASE_URL ||
  "https://momfident-backend-582023308430.europe-west1.run.app"
).replace(/\/$/, "");
